import React, { useEffect, useState, useContext } from 'react';
import axios from "../../../common/axios";
import {
    Alert,
    Typography
} from 'antd';
import CircularLoader from "../../../common/CircularLoader";
import {UserContext} from "../../../common/UserContext";
import {BrandContext} from "../../../common/BrandContext";
import TestQuestion from "./TestQuestion";
import PageTabs from "./PageTabs";
import TestHeader from "./TestHeader";
import {Download} from "@mui/icons-material/";
import Button, {BUTTON_TYPE} from "../../../common/Button";
import {ArrowLeftIcon} from "../../../common/icons";

const { Text } = Typography;

const TestResult = (props) => {
    const { testResultId, showUserAnswers = true , handleBack } = props;
    const { user } = useContext(UserContext);

    const [testResultData, setTestResultData] = useState();
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState();

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 5;

    useEffect(() => {
        if (testResultId === undefined) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(undefined);

        axios
            .get('/web/ui/test/testResult', { params: { testResultId } })
            .then((response) => {
                setTestResultData(response.data);
            })
            .catch((error) => {
                console.error('Error loading test results', error);
                setError(error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [testResultId]);

    const handlePrint = () => {
        if (!testResult) {
            return;
        }
        var url =
            "/reports/studentTestResultsReport.action?testAssignmentId=" +
            testResult.testAssignmentId +
            "&studentId=" +
            testResult.userId;
        var pdfWin = window.open(url);
        pdfWin.focus();
    };

    const formatTimestamp = (timestamp) =>
        timestamp ? user.dateTimeMinuteFormat.format(timestamp) : 'N/A';

    if (isLoading) {
        return <CircularLoader />;
    }

    if (error) {
        return <Alert message={error} type="error" />;
    }

    if (testResultData == undefined) {
        return <div className="ch-error-text">Failed to fetch test results.</div>;
    }

    const { test, testResult, questionResults } = testResultData;
    if (!test || !testResult || !questionResults) {
        return <div className="ch-text-error">Invalid test result data.</div>;
    }

    const totalPages = Math.ceil(test.testQuestionBeans.length / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = currentPage * pageSize;
    const currentQuestions = test.testQuestionBeans.slice(startIndex, endIndex);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const renderQuestions = () => {
        return currentQuestions.map((testQuestion, index) => {
            const questionResult = questionResults.find(
                (qr) => qr.questionId === testQuestion.questionId
            );
            const questionNumber = startIndex + index + 1;

            return <TestQuestion key={testQuestion.questionId} questionResult={questionResult} testQuestion={testQuestion} questionNumber={questionNumber} showExamCitations={false} showUserAnswers={showUserAnswers} />
        });
    };

    return (
        <div
            className="ch-test-result margin--l"
            data-test-id={test.testId}
            data-test-type={test.testType}
            data-test-purpose={test.testPurpose}
            data-test-status={testResult.testAssignmentStatus}
            data-test-assignment-id={test.testAssignmentId}
            data-test-result-id={testResult.testResultId}
            data-student-id={testResult.userId}
        >
            <TestHeader test={test} testResult={testResult}
                        printButton={<Button aria-label={'Download test results as PDF'} onClick={handlePrint}>PDF s<Download/></Button>}
                        backButton={handleBack != undefined  ? <Button type={BUTTON_TYPE.TEXT} onClick={handleBack}><ArrowLeftIcon/> Back to student results</Button> : null}
            />
            <PageTabs totalPages={totalPages} pageSize={pageSize} test={test} questionResults={questionResults} currentPage={currentPage} onPageChange={handlePageChange}/>
            <div>{renderQuestions()}</div>
        </div>
    );
};

export default TestResult;
